import React, {useEffect, useState} from 'react';
import classes from "./timer.module.css";
import {texts} from "../../../../translate";

const Timer = ({lang, time, bonus, hint}) => {
    const [days, setDays] = useState(0)
    const [hours, setHours] = useState(0)
    const [minutes, setMinutes] = useState(0)
    const [finished, setFinished] = useState(false)
    const [showHint, setShowHint] = useState(false)

    function setTimer(){
        const left = Math.max(0, time - Date.now())
        const daysT = Math.trunc(left / (1000 * 60 * 60 * 24))
        const hoursT = Math.trunc((left - daysT * 1000 * 60 * 60 * 24) / (1000 * 60 * 60))
        const minutesT = Math.trunc((left - daysT * 1000 * 60 * 60 * 24 - hoursT * 1000 * 60 * 60) / (1000 * 60))
        setDays(daysT)
        setHours(hoursT)
        setMinutes(minutesT)
        setFinished(left <= 0)
    }

    useEffect(()=>{
        setTimer()
        const id = setInterval(setTimer, 10000)
        return () => clearInterval(id)
    },[time])

    const TimerItems = ({value})=>{
        return(
            <div>
                <div className={classes.block1}></div>
                <div className={classes.block2}></div>
                <div className={classes.block3}></div>
                <div className={classes.value}>{value}</div>
            </div>
        )
    }

    return (
        <div
            className={classes.wrap}
            title={hint || texts[lang].presale.dateHint}
            onMouseEnter={() => setShowHint(true)}
            onMouseLeave={() => setShowHint(false)}
            onClick={(e) => {
                e.stopPropagation()
                setShowHint((open) => !open)
            }}
        >
            <div className={classes._}>
                <div className={classes.block}>
                    <TimerItems value={days}/>
                    <div style={{opacity:bonus?1:.5}}>{texts[lang].bonuses.day}</div>
                </div>
                <div className={classes.mt}>:</div>
                <div className={classes.block}>
                    <TimerItems value={hours}/>
                    <div style={{opacity:bonus?1:.5}}>{texts[lang].bonuses.hour}</div>
                </div>
                {bonus && <div className={classes.mt}>:</div>}
                {bonus && <div className={classes.block}>
                    <TimerItems value={minutes}/>
                    <div style={{opacity:bonus?1:.5}}>{texts[lang].bonuses.minute}</div>
                </div>}
            </div>
            {showHint && (
                <div className={classes.hint}>{hint || texts[lang].presale.dateHint}</div>
            )}
            <span className={classes.finished} data-finished={finished ? '1' : '0'}></span>
        </div>
    );
};

export default Timer;
